// extracted by extract-css-chunks-webpack-plugin
module.exports = {"pensionPrognosis":"Ck9-cL","markdown":"UyjXap"};